import React from 'react';
import { makeStyles, Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
 
    minWidth: 220,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 300,
      width: '100%',
    },
  },
}));

export default function DownloadButton() {
  const classes = useStyles();

  return (
    <Button variant="contained" color="primary" size="large" className={classes.root}>
      Download the App
    </Button>
  );
}
